import React from 'react';

import {AutoArchiveBanner} from './AutoArchiveBanner';
import {LicenseBanners} from './LicenseBanners';

export const HomeBanners = () => (
  <div aria-live='polite' className='gap-x1-half flex flex-col empty:hidden'>
    <LicenseBanners />
    <AutoArchiveBanner />
  </div>
);
